import { render, staticRenderFns } from "./order-list-of-logs.vue?vue&type=template&id=491008d2"
import script from "./order-list-of-logs.vue?vue&type=script&lang=js"
export * from "./order-list-of-logs.vue?vue&type=script&lang=js"
import style0 from "./order-list-of-logs.vue?vue&type=style&index=0&id=491008d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports